import { render } from "./FilterDistributorByUser.vue?vue&type=template&id=dea0a590"
import script from "./FilterDistributorByUser.vue?vue&type=script&lang=js"
export * from "./FilterDistributorByUser.vue?vue&type=script&lang=js"
script.render = render

export default script